<span *ngIf="![3].includes(shopping_cart && shopping_cart.orderTypeId); else alternateTitle">
  <h6 class="display-6 mb-0">{{ device.manufacturer }}</h6>
  <h3 [ngClass]="{ 'mb-0': !is_bp_device }">{{ device.model }}</h3>
  <h4 *ngIf="is_bp_device">{{ constructBusinessPurpose() }}</h4>
</span>

<p *ngIf="device.description !== ''" class="mt-2">
  {{ device.description }}
</p>

<ng-template #alternateTitle>
  <h3 [ngClass]="{ 'mb-0': !is_bp_device }">{{ constructAssetTitle() }}</h3>
  <h4 *ngIf="is_bp_device">{{ constructBusinessPurpose() }}</h4>
</ng-template>
